import React from 'react';

const ContentBody = ({children})=> {
    return (
        /*Main content*/
        <section className="content">{children}</section>
    );
}
export default ContentBody;
